(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('[data-cta-banner-video]').forEach((video) => {
    video.muted = true;
    video.setAttribute('playsinline', '');
    if (reduceMotion.matches) {
      video.pause();
      return;
    }
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  });

  function sectionRoot(banner) {
    return banner.closest('.shopify-section') || banner.parentElement;
  }

  function groupConsecutive(sections) {
    const groups = [];
    let current = [];

    sections.forEach((section) => {
      if (!current.length) {
        current.push(section);
        return;
      }

      const prev = current[current.length - 1];
      if (prev.nextElementSibling === section) {
        current.push(section);
        return;
      }

      if (current.length > 1) groups.push(current);
      current = [section];
    });

    if (current.length > 1) groups.push(current);
    return groups;
  }

  function unwrapSwipe(wrapper) {
    const parent = wrapper.parentNode;
    if (!parent) return;

    const track = wrapper.querySelector('.index-cta-swipe__track');
    const children = track ? [...track.children] : [];
    children.forEach((child) => parent.insertBefore(child, wrapper));
    wrapper.remove();
  }

  function wrapSwipe(group) {
    if (group[0].closest('.index-cta-swipe')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'index-cta-swipe';
    wrapper.setAttribute('data-cta-swipe', '');

    const track = document.createElement('div');
    track.className = 'index-cta-swipe__track';
    track.setAttribute('data-cta-swipe-track', '');

    const dots = document.createElement('div');
    dots.className = 'index-cta-swipe__dots';
    dots.setAttribute('data-cta-swipe-dots', '');
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'CTA pages');

    group[0].parentNode.insertBefore(wrapper, group[0]);
    group.forEach((section, index) => {
      track.appendChild(section);

      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'index-cta-swipe__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('data-cta-swipe-dot', '');
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      dots.appendChild(dot);
    });

    wrapper.appendChild(track);
    wrapper.appendChild(dots);
    bindSwipe(wrapper);
  }

  function bindSwipe(wrapper) {
    const track = wrapper.querySelector('[data-cta-swipe-track]');
    const dots = [...wrapper.querySelectorAll('[data-cta-swipe-dot]')];
    if (!track || dots.length < 2) return;

    const slides = [...track.children];

    function setActive(index) {
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'auto',
      });
      setActive(index);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goTo(index));
    });

    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const slideWidth = slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth;
          const index = Math.round(track.scrollLeft / Math.max(slideWidth, 1));
          setActive(Math.max(0, Math.min(slides.length - 1, index)));
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function syncSwipe() {
    if (mobileQuery.matches) {
      const banners = [...document.querySelectorAll('[data-cta-banner]')];
      const sections = banners.map(sectionRoot).filter(Boolean);
      const unique = [...new Set(sections)];
      groupConsecutive(unique).forEach(wrapSwipe);
      return;
    }

    document.querySelectorAll('[data-cta-swipe]').forEach(unwrapSwipe);
  }

  syncSwipe();

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncSwipe);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncSwipe);
  }
})();
